import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, MapPin, Phone, Mail } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";

const OFFICES = [
  {
    city: "Dublin (Head Office)",
    address_lines: ["AGS Cleaning Services", "Suite 4, 12 Custom House Quay", "Dublin 1, D01 X4YH"],
    phone: "+353 87 381 6923",
    email: "info@ags-services.ie",
    note: "Registered office · Operations & Client Services",
  },
  {
    city: "Cork",
    address_lines: ["AGS Cleaning Services", "South Mall Business Centre", "Cork, T12 RFK7"],
    phone: "+353 87 381 6923",
    email: "info@ags-services.ie",
    note: "Munster Operations Hub",
  },
  {
    city: "Galway",
    address_lines: ["AGS Cleaning Services", "Mervue Business Park", "Galway, H91 P6XX"],
    phone: "+353 87 381 6923",
    email: "info@ags-services.ie",
    note: "Connacht Operations Hub",
  },
];

export default function RegisteredOffices() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="offices-page" className="bg-white text-[#050B14]">
      <Navigation />
      <main>
        <section className="relative bg-[#F4F8FC] pt-40 md:pt-48 pb-14 md:pb-20 border-b border-[#E5EBF2]">
          <div className="container-ags">
            <Link
              to="/"
              className="group inline-flex items-center gap-2 text-sm font-medium text-[#0E2A57] hover:text-[#2BB6E5] transition-colors mb-8"
            >
              <ArrowLeft size={16} className="transition-transform group-hover:-translate-x-1" />
              Back to home
            </Link>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-16 bg-[#2BB6E5]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#0E2A57] font-semibold">
                Important Information
              </span>
            </div>
            <h1 className="font-heading font-extrabold text-4xl md:text-6xl leading-[1.0] tracking-[-0.04em] text-[#0E2A57]">
              Our Registered Offices
            </h1>
            <p className="mt-6 text-[#475569] text-lg leading-relaxed max-w-3xl">
              We are headquartered in Dublin with regional operations hubs across Ireland. Visits are by appointment only — please call ahead.
            </p>
          </div>
        </section>

        <section className="bg-white py-16 md:py-24">
          <div className="container-ags grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E5EBF2] border border-[#E5EBF2]">
            {OFFICES.map((o, i) => (
              <article
                key={o.city}
                data-testid={`office-${i}`}
                className="bg-white p-8 md:p-10"
              >
                <div className="text-[11px] uppercase tracking-[0.22em] text-[#2BB6E5] font-semibold">
                  {o.note}
                </div>
                <h2 className="mt-3 font-heading font-bold text-2xl text-[#0E2A57] tracking-tight">
                  {o.city}
                </h2>
                <div className="mt-5 flex items-start gap-3 text-[#475569] text-sm leading-relaxed">
                  <MapPin size={16} className="text-[#737373] flex-shrink-0 mt-1" />
                  <div>
                    {o.address_lines.map((l) => (
                      <div key={l}>{l}</div>
                    ))}
                  </div>
                </div>
                <div className="mt-4 flex items-center gap-3 text-[#475569] text-sm">
                  <Phone size={14} className="text-[#737373]" />
                  <span>{o.phone}</span>
                </div>
                <div className="mt-2 flex items-center gap-3 text-[#475569] text-sm">
                  <Mail size={14} className="text-[#737373]" />
                  <span>{o.email}</span>
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
